import { PropsCategoriesSelected } from "./types";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { useStyles } from "./styles";
import { icons } from "../../../../../../../../utils/icons";
import { DropListSubCategorie, SelectedSubcategoryInterface } from "../../Context";
import { useTranslation } from "react-i18next";
import React from "react";


const CategoriesAdded = ({ handleEditSelection, handleRemoveSelection, selectedSubcategories }: PropsCategoriesSelected) => {

    const styles = useStyles()
    const { t } = useTranslation()
    console.log({selectedSubcategories})

    const flattenDropList = (dropList: DropListSubCategorie[]): Record<string, any> => {
        const result: Record<string, any> = {};
        let index = 0;

        const traverse = (node: DropListSubCategorie) => {
            const { label, value, requestText, textRequest, dropList } = node;
            result[index] = {
                label,
                value,
                requestText,
                ...(textRequest ? { textRequest } : {}),
                dropList: dropList.map((child) => ({
                    label: child.label,
                    value: child.value,
                    requestText: child.requestText,
                    ...(child.textRequest ? { textRequest: child.textRequest } : {}),
                    dropList: child.dropList,
                })),
            };

            const currentIndex = index;
            index++;

            dropList.forEach((child) => traverse(child));

            return currentIndex;
        };

        // Solo recorremos raíces
        dropList.forEach((node) => traverse(node));

        return result;
    }


    const getSubNames = (sub: SelectedSubcategoryInterface) => {
        const list = flattenDropList(sub.dropList)
        const textFormatted = Object.values(list).map(item => item.label);
        const result = textFormatted.join(" / ");
        const resultWithText = textFormatted.length>0 ? `${result}${(sub.textRequest?.trim() ?? '').length > 0 ? `: ${sub.textRequest}` : ''}` : (sub.textRequest?.trim() ?? '').length > 0 ? sub.textRequest : ''

        return (
            <Box sx={styles.dropList}>
                <Typography variant="body2">
                    {resultWithText}
                </Typography>
            </Box>
        );
    }

    return (
        <Box>
            {selectedSubcategories.map((sub) => (
                <Box key={sub.id} sx={styles.mainContainer}>
                    <Box sx={styles.iconSetting} >{icons('setting')}</Box>

                    <Box sx={styles.superior}>
                        <Box sx={styles.titleAndIcon}>
                            <Typography sx={styles.title} variant="subtitle1" fontWeight="bold">{`${sub.categoryName} / ${sub.name}`}</Typography>
                            <Box>
                                <Tooltip title={t('ToolTips.edit')}>
                                    <IconButton onClick={() => { handleEditSelection(sub.idArray ?? 0, sub) }}>{icons('edit')}</IconButton>

                                </Tooltip>
                                <Tooltip title={t('ToolTips.delete')}>
                                    <IconButton onClick={() => { handleRemoveSelection(sub.idArray ?? 0) }}>{icons('delete')}</IconButton>

                                </Tooltip>
                            </Box>
                        </Box>

                        <Box>
                            {(sub.dropList.length > 0 || (sub.textRequest?.trim() ?? '').length > 0) && (<>{getSubNames(sub)}</>)}
                        </Box>
                    </Box>

                </Box>
            ))}
        </Box>
    );
};

export default CategoriesAdded;
